import * as React from "react";
import { cn } from "@/lib/cn";

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: "light" | "dark" | "gradient";
  interactive?: boolean;
};

const light =
  "bg-white border border-neutral-200/80 text-neutral-900 shadow-[0_1px_0_rgba(255,255,255,0.6)_inset,0_8px_30px_-12px_rgba(15,23,42,0.06)]";
const dark =
  "bg-neutral-950 text-white border border-neutral-900 shadow-[0_1px_0_rgba(255,255,255,0.05)_inset,0_8px_30px_-12px_rgba(0,0,0,0.5)]";
const gradient =
  "border border-transparent bg-gradient-to-br from-[#0950CC] via-[#3b82f6] to-[#22d3ee] text-neutral-900 shadow-[0_8px_30px_-12px_rgba(9,80,204,0.4)]";

const interactiveLight =
  "transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(15,23,42,0.12)]";
const interactiveDark =
  "transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.6)]";

export function GlassCard({
  className,
  variant = "light",
  interactive = true,
  children,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-3xl",
        variant === "light" && light,
        variant === "dark" && dark,
        variant === "gradient" && gradient,
        interactive && variant === "dark" && interactiveDark,
        interactive && variant !== "dark" && interactiveLight,
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

// Backwards-compatible alias
export { GlassCard as Card };
